import { render, staticRenderFns } from "./IconEmojiSad.vue?vue&type=template&id=11be0e72&"
import script from "./IconEmojiSad.vue?vue&type=script&lang=js&"
export * from "./IconEmojiSad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports